import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=94678b04&"
import script from "./GenericModal.vue?vue&type=script&lang=js&"
export * from "./GenericModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GenericModal.vue"
export default component.exports